import React from 'react';
import {CardActions} from '../Card/CardActions';
import type {CardActionsProps} from '../Card/CardActions';

type FuelJustifyContent = 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';

export interface ModalActionsProps extends CardActionsProps {
    /**
     * Position of items within ModalActions
     * @default 'flex-end'
     */
    justifyContent?: FuelJustifyContent;
}

export const ModalActions = React.forwardRef<any, ModalActionsProps>(
    (
        {
            children,
            justifyContent = 'flex-end',
            ...props
        },
        ref
    ) => {
        return (
            <CardActions
                justifyContent={justifyContent}
                ref={ref}
                {...props}
            >
                {children}
            </CardActions>
        );
    });

ModalActions.displayName = 'ModalActions';
